import React from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { useCategories } from "@/hooks/useCategories";

interface CategoryProps {
  isRTL: boolean;
}

export const Categories = ({ isRTL }: CategoryProps) => {
  const { visibleCategories, isLoading } = useCategories();

  const getIconComponent = (iconName: string) => {
    const IconComponent = (LucideIcons as any)[iconName];
    return IconComponent || LucideIcons.Calendar;
  };

  if (isLoading) {
    return (
      <section className="py-8">
        <div className="container">
          <h2 className="text-2xl font-bold mb-8 bg-gradient-to-r from-secondary to-gold bg-clip-text text-transparent">
            {isRTL ? "تصفح الأقسام" : "Browse Categories"}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="animate-pulse bg-card rounded-xl p-6 h-28 border border-primary/10"></div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8">
      <div className="container">
        <h2 className="text-2xl font-bold mb-8 bg-gradient-to-r from-secondary to-gold bg-clip-text text-transparent">
          {isRTL ? "تصفح الأقسام" : "Browse Categories"}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {visibleCategories.map((category) => {
            const IconComponent = getIconComponent(category.icon);
            return (
              <Link
                key={category.id}
                to={category.path}
                className="group flex flex-col items-center justify-center p-6 bg-card rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-primary/10 hover:border-primary/30"
              >
                <div className={`mb-3 ${category.color} p-3 rounded-lg bg-primary/5 group-hover:bg-primary/10 transition-colors`}>
                  <IconComponent
                    size={32}
                    className="transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <span className="text-sm font-medium text-foreground text-center group-hover:text-primary transition-colors">
                  {isRTL ? category.name_ar : category.name_en}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
